import * as React from 'react';

function SvgNoFilters(props) {
  return (
    <svg width={214} height={175} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.435 169.359c6.235 6.214 18.055 3.726 25.46-1.86 6.39-4.822 10.887-12.835 17.401-17.427 10.901-7.682 25.053-4.25 37.186 1.616 8.583 4.148 17.986 9.492 26.35 5.661 5.887-2.696 9.85-9.558 11.936-16.894 1.006-3.542 1.711-7.386 3.717-10.159 1.193-1.648 2.769-2.796 4.39-3.756 14.791-8.767 33.816-3.288 48.156-13.069 9.682-6.606 15.707-19.425 18.211-32.902 2.503-13.477 1.884-27.704.887-41.687-.709-9.937-1.83-20.556-7.108-28.365C200.438 2.261 191.082-1.02 182.716.273c-8.367 1.293-15.868 6.553-22.43 12.832-8.208 7.834-15.759 17.668-25.967 20.642-6.953 2.025-14.34.592-21.568-.042-12.082-1.056-24.122.16-36.088 1.535-11.455 1.315-22.99 2.783-33.838 7.094-7.677 3.051-31.271 14.461-39.09 32.617-1.863 4.329-13.167 65.641 15.7 94.408z"
        fill="#E2F4F2"
      />
      <path d="M31 49a4 4 0 014-4h158a4 4 0 014 4v112H31V49z" fill="#595959" />
      <path d="M14 163c0 6.627 5.373 12 12 12h176c6.627 0 12-5.373 12-12v-2H14v2z" fill="#8C8C8C" />
      <path d="M94.833 165h38.334l3.833-4H91l3.833 4z" fill="#BFBFBF" />
      <rect x={37} y={52} width={154} height={103} rx={2} fill="#D9D9D9" />
      <path d="M168 32a7 7 0 1114 0v13h-14V32z" fill="#E8E8E8" />
      <mask id="no-filters_svg__a" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168 25H67.63a8 8 0 00-8 8v122.097h108.737V45h.003V33a8 8 0 018-8H168z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168 25H67.63a8 8 0 00-8 8v122.097h108.737V45h.003V33a8 8 0 018-8H168z"
        fill="#fff"
      />
      <path
        d="M59.63 155.097h-1v1h1v-1zm108.737 0v1h1v-1h-1zm0-110.097v-1h-1v1h1zm.003 0v1h1v-1h-1zM67.63 26H168v-2H67.63v2zm-7 7a7 7 0 017-7v-2a9 9 0 00-9 9h2zm0 122.097V33h-2v122.097h2zm53.368-1H59.629v2h54.369v-2zm54.369 0h-54.369v2h54.369v-2zm-1-109.097v110.097h2V45h-2zm1.003-1h-.003v2h.003v-2zm1 1V33h-2v12h2zm0-12a7 7 0 017-7v-2a9 9 0 00-9 9h2zm-1.003-7h8.003v-2h-8.003v2zM168 26h.367v-2H168v2z"
        fill="#E7E7E7"
        mask="url(#no-filters_svg__a)"
      />
      <path
        fill="#D9D9D9"
        d="M112.059 43.447h38.835v2.913h-38.835zM112.059 51.213h38.835v2.913h-38.835zM112.059 59.951h20.388v2.913h-20.388zM112.059 81.311h38.835v2.913h-38.835zM112.059 88.107h38.835v2.913h-38.835zM112.059 96.845h20.388v2.913h-20.388zM112.059 118.204h38.835v2.913h-38.835zM112.059 126.942h38.835v2.913h-38.835zM112.059 135.68h20.388v2.913h-20.388z"
      />
      <circle cx={86.814} cy={53.155} r={11.65} fill="#38B2A6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.275 52.024l6.061-5.47a.7.7 0 01.967-.002l3 2.704v-.483c0-.177.137-.323.303-.323h.83c.166-.001.302.144.302.321l-.002 1.789 1.614 1.448a.83.83 0 01.089 1.112.71.71 0 01-1.042.098l-.09-.08-.008 6.285c0 .273-.213.5-.469.5l-3.457.004.007-5.818-3.11.004-.007 5.818-3.457.004c-.257 0-.468-.225-.468-.499l.008-6.285-.09.08a.712.712 0 01-.484.194.757.757 0 01-.573-.273c-.271-.353-.226-.854.076-1.128z"
        fill="#fff"
      />
      <circle cx={86.814} cy={91.019} r={11.65} fill="#38B2A6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.275 89.888l6.061-5.47a.7.7 0 01.967-.002l3 2.704v-.483c0-.177.137-.323.303-.323h.83c.166 0 .302.144.302.321l-.002 1.789 1.614 1.448a.83.83 0 01.089 1.112.71.71 0 01-1.042.098l-.09-.08-.008 6.285c0 .273-.213.5-.469.5l-3.457.004.007-5.818-3.11.004-.007 5.818-3.457.004c-.257 0-.468-.225-.468-.499l.008-6.285-.09.08a.712.712 0 01-.484.195.757.757 0 01-.573-.274c-.271-.353-.226-.854.076-1.128z"
        fill="#fff"
      />
      <circle cx={86.814} cy={128.884} r={11.65} fill="#38B2A6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.275 127.752l6.061-5.471a.7.7 0 01.967-.001l3 2.704v-.483c0-.177.137-.323.303-.323l.83-.001c.166 0 .302.145.302.322l-.002 1.789 1.614 1.448a.83.83 0 01.089 1.112.71.71 0 01-1.042.098l-.09-.081-.008 6.286c0 .273-.213.499-.469.5l-3.457.004.007-5.818-3.11.004-.007 5.818-3.457.004c-.257 0-.468-.226-.468-.499l.008-6.285-.09.08a.71.71 0 01-.484.194.754.754 0 01-.573-.273c-.271-.353-.226-.854.076-1.128z"
        fill="#fff"
      />
      <rect
        x={158.317}
        y={117.585}
        width={6.365}
        height={32.327}
        rx={3.183}
        transform="rotate(-28 158.317 117.585)"
        fill="#595959"
      />
      <ellipse
        cx={147.059}
        cy={93.023}
        rx={25.461}
        ry={25.385}
        transform="rotate(-28 147.059 93.023)"
        fill="#fff"
      />
      <circle r={4} transform="matrix(1 0 0 -1 147 106)" fill="#FCCE01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M146.75 76c1.795 0 3.25 1.404 3.25 3.136v16.728c0 1.732-1.455 3.136-3.25 3.136s-3.25-1.404-3.25-3.136V79.136c0-1.732 1.455-3.136 3.25-3.136z"
        fill="#FCCE01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.584 120.34c15.132-8.046 20.896-26.798 12.874-41.885s-26.791-20.795-41.923-12.749c-15.132 8.046-20.895 26.798-12.874 41.885 8.022 15.087 26.792 20.794 41.923 12.749zm-2.607-4.903c12.416-6.602 17.145-21.988 10.563-34.367-6.582-12.38-21.982-17.063-34.398-10.461-12.416 6.602-17.145 21.988-10.563 34.367 6.582 12.379 21.983 17.062 34.398 10.461z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgNoFilters;
